module.exports = __webpack_public_path__ + "img/1.88.85bccd01.png";